const animations = {
    fast: "150ms",
    base: "300ms",
    slow: "500ms",
};

export default animations;
